import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  PLATFORM_ID,
  signal
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { iconArrowRight } from 'main/icons/icon-arrow-right';
import { fromWindowEvent } from 'core/utils/rxjs/window-event';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WindowService } from 'core/services/window.service';

@Component({
  selector: 'app-to-top-button',
  templateUrl: './to-top-button.component.html',
  styleUrls: ['./to-top-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToTopButtonComponent {
  readonly arrowIcon = iconArrowRight;

  $active = signal(false);

  constructor(
    private win: WindowService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    fromWindowEvent('scroll').pipe(takeUntilDestroyed()).subscribe(() => {
      this.$active.set(!!this.win.scrollY && this.win.scrollY > 300);
    });
    this.$active.set(!!this.win.scrollY && this.win.scrollY > 300);
  }

  scrollToTop(): void {
    if (isPlatformBrowser(this.platformId) && this.document) {
      this.win.scrollTo(0, 0);
    }
  }
}
